import React from 'react';
import { CarrierIcon, CartIcon, DeliveryIcon, InterchangeIcon, RetrofitCancelIcon, ShipmentIcon, StorageNotHiredIcon, TransferIcon, TransportNotHired, ArrivalBranchIcon } from '../../../../pages/Tracking/components/Details/components/AllowanceRelease/icons';
import { TMSStepTypes, WMSStepTypes } from "../../../../pages/Tracking/components/TrackingNFList/NewTrackingNFItem/StatusFlow/enums";

const IconsTMS = {
  [TMSStepTypes.INTERCHANGE]: ({
    uuid, 
    radiosColor1, 
    radiosColor2,
    color
  }) => 
    <InterchangeIcon 
      uniqueId={uuid} 
      radiosColor1={radiosColor1} 
      radiosColor2={radiosColor2} 
      color={color} 
    />,
  [TMSStepTypes.NOT_INCLUDED]: () => 
    <TransportNotHired />,
  [TMSStepTypes.CANCELED]: () =>
    <RetrofitCancelIcon />,
  [TMSStepTypes.INTERCHANGE]: ({
    uuid, 
    radiosColor1, 
    radiosColor2,
    color
  }) =>  
    <InterchangeIcon 
      uniqueId={uuid} 
      radiosColor1={radiosColor1} 
      radiosColor2={radiosColor2} 
      color={color} 
    />,
  [TMSStepTypes.SHIPMENT]: ({
    uuid, 
    radiosColor1, 
    radiosColor2,
    color
  }) =>
    <ShipmentIcon
      uniqueId={uuid} 
      radiosColor1={radiosColor1} 
      radiosColor2={radiosColor2} 
      color={color}  
    />,
  [TMSStepTypes.TRANSFER_DELIVERY]: ({
    uuid, 
    radiosColor1, 
    radiosColor2,
    color
  }) => 
    <TransferIcon 
      uniqueId={uuid} 
      radiosColor1={radiosColor1} 
      radiosColor2={radiosColor2} 
      color={color}  
    />,
  [TMSStepTypes.CARRIER]: ({
    uuid, 
    radiosColor1, 
    radiosColor2,
    color
  }) =>
    <CarrierIcon
      uniqueId={uuid} 
      radiosColor1={radiosColor1} 
      radiosColor2={radiosColor2} 
      color={color}  
    />,
  [TMSStepTypes.DELIVERY]: ({
    uuid, 
    radiosColor1, 
    radiosColor2,
    color
  }) =>
    <DeliveryIcon 
      uniqueId={uuid} 
      radiosColor1={radiosColor1} 
      radiosColor2={radiosColor2} 
      color={color} 
    />,
  [TMSStepTypes.ARRIVAL_BRANCH]: ({
    uuid, 
    radiosColor1, 
    radiosColor2,
    color
  }) =>
    <ArrivalBranchIcon 
      uniqueId={uuid} 
      radiosColor1={radiosColor1} 
      radiosColor2={radiosColor2} 
      color={color} 
    />
}

const IconsWMS = {
  [WMSStepTypes.SEPARATION]: ({
    uuid, 
    radiosColor1, 
    radiosColor2,
    color
  }) => 
    <CartIcon 
      uniqueId={uuid} 
      radiosColor1={radiosColor1} 
      radiosColor2={radiosColor2} 
      color={color} 
    />,
  [WMSStepTypes.INTERCHANGE]: ({
    uuid, 
    radiosColor1, 
    radiosColor2,
    color
  }) => 
    <InterchangeIcon 
      uniqueId={uuid} 
      radiosColor1={radiosColor1} 
      radiosColor2={radiosColor2} 
      color={color} 
    />,
  [WMSStepTypes.CANCELED]: () =>
    <RetrofitCancelIcon />,
  [WMSStepTypes.NOT_INCLUDED]: () => 
    <StorageNotHiredIcon />,
}

export { IconsTMS, IconsWMS };
